<script setup>
import MediaBankEntry from './util/media-bank-entry.vue';

const props = defineProps({
    containerRef: {
        type: String,
        required: true
    },
    uuid: {
        type: String,
        require: true
    },
    content: {
        type: Object,
        required: false
    }
})
</script>
<template>
    <div class="my-8">
        <MediaBankEntry
            v-if="content"
            class="flex justify-center text-center download-button"
            :container-ref="containerRef"
            :block-uuid="uuid"
            :block-content="content"
            :media-bank-entry-id="content.media_bank_entry_id"
            property-name="media_bank_entry_id"
        ></MediaBankEntry>
    </div>
</template>
<style scoped>
:deep(.download-button a) {
    color: inherit;
}
</style>
